import axiosInstance from "./axiosInstance";

export async function GetSearchData(searchPrompt: string,
  nResults: number,
  searchIn?: string,
  show?: string,
  orderBy?: string,
  paging?: number
) {
  try {
    const response = await axiosInstance.post('/get_search_results/', {
      search_prompt: searchPrompt,
      n_results: nResults,
      searchIn: searchIn,
      show: show,
      orderBy: orderBy,
      p: paging?? 0,
    });
    return await response.data;
  }
  catch (err) {
    console.log(err);
    return {};
  }
}
